import { RequestRetrievalActionProps, useRequestRetrievalAction } from './request-retrieval-action.hook';
import { makeRequestRetrievalActionProps } from './request-retrieval-action-props.map';
import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { parseErrorMessage } from '../../../../../core/api/api.context';

export function RequestRetrievalModal({ order, ...rest }: RequestRetrievalActionProps) {
  const [state, handlers] = useRequestRetrievalAction({ order, ...rest });

  const props = makeRequestRetrievalActionProps({
    isLoading: state.loading,
    onCancel: handlers.onCancelIntent,
    onConfirm: handlers.onConfirmRequestRetrieval,
    errorMessage: parseErrorMessage(state.error?.message)
  });

  return <ConfirmationModal {...props} />;
}
